// This is a static Task

import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class Task extends Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <li onClick={() => this.props.onRemoveTask(this.props.index, this.props.self)}>
        <p> Title: {this.props.task.title}</p>
        <p> Description: {this.props.task.description}</p>
      </li>
    )
  }
}

export default Task;



// WEBPACK FOOTER //
// ./client/components/task.jsx